<template>
  <div class="container lms-wrapper no-right-sidebar">
    <div class="lms-sidebar">
      <div class="lms-sidebar-body">
        <vue-custom-scrollbar :style="`height: ${scrollHeight.nav}px`">
          <div :class="`card ${$store.state.app.isMobile ? 'bd-0' : ''}`">
            <div class="card-body">
              <student-nav @route-changed="toggleNavbar(false)"></student-nav>
            </div>
          </div>
        </vue-custom-scrollbar>
      </div>
    </div>
    <div class="lms-content">
      <div class="lms-content-body">
        <vue-custom-scrollbar
          :style="`height: ${scrollHeight.content}px; position: relative; `"
        >
          <!-- Төлбөрийн дэлгэрэнгүй {{$route.params.id}} -->
          <!-- @on-pay-success="stepHasPayment=false; modalSuccess= true" -->

          <go-payment
            :invoiceId="parseInt($route.params.id, 10)"
            @on-pay-success="onPaySuccess"
          >
            <!-- <div class="pd-l-20 pd-t-100 wd-100p btn-group">
              <button @click="stepCur--" class="btn btn-warning">Сургалтын гэрээ</button>
              <button class="btn btn-primary">Төлбөр</button>
              </div>-->
          </go-payment>
        </vue-custom-scrollbar>
      </div>
    </div>

    <b-modal
      v-model="modalSuccess"
      hide-footer
      centered
      title="Амжилттай"
      @close="courseDetail()"
      no-close-on-esc
      no-close-on-backdrop
    >
      <div class="mg-x-20" v-if="invoiceSuccessRdy">
        <template v-if="invoiceSuccess.product.objectTypeId == 115">
          <div class="text-center pd-20">
            <h5
              class="text-truncate tx-14-f mg-b-5"
              style="white-space: normal; max-height: 40px; min-height: 40px"
            >
              {{ invoiceSuccess.product.task }} сургалтад амжилттай бүртгүүллээ.
            </h5>
            <div v-if="invoiceSuccessRdy && checkCourseIsActive() == 0">
              Сургалтын эхлэх хугацаа:
              {{
                invoiceSuccess.product.date.start
                  | moment("YYYY.MM.DD HH:mm, dddd")
              }}
            </div>
            <img src="assets/svg/complete.svg" />
          </div>
          <div class="text-center">
            <button
              v-if="invoiceSuccessRdy && checkCourseIsActive() == 1"
              @click="courseDetail()"
              class="btn btn-sm pd-x-15 btn-success btn-uppercase"
            >
              <feather type="check-circle" class="mg-r-5"></feather>
              {{ "Сургалтыг эхлүүлэх" }}
            </button>
            <router-link
              v-else
              to="/"
              class="btn btn-sm pd-x-15 btn-primary btn-uppercase"
            >
              <feather type="home" class="mg-r-5"></feather>Эхлэл хуудас
            </router-link>
          </div>
        </template>
        <template v-else>
          <div class="text-center pd-20">
            <h5
              class="text-truncate tx-14-f mg-b-5"
              style="white-space: normal; max-height: 40px; min-height: 40px"
            >
              {{ invoiceSuccess.product.task }} худалдан авалт амжилттай боллоо.
            </h5>

            <img src="assets/svg/complete.svg" />
          </div>
          <div class="text-center">
            <div class="btn-group">
              <button v-if="hasEbarimt" @click="goToEbarimt()" class="btn btn-sm btn-primary">
                <feather type="file-text" class="mg-r-5"></feather>
                И-баримт авах
              </button>
              <button
                v-if="invoiceSuccessRdy"
                @click="pushInvoiceDetail()"
                class="btn btn-sm pd-x-15 btn-success btn-uppercase"
              >
                <feather type="check-circle" class="mg-r-5"></feather>
                Үргэлжлүүлэх
              </button>
            </div>
          </div>
        </template>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";
import vueCustomScrollbar from "vue-custom-scrollbar";
import M from "minimatch";
const moment = require("moment");

export default {
  components: {
    vueCustomScrollbar,
    studentNav: () => ({
      component: import("@/views/modules/lms/student/components/nav.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    goPayment: () => ({
      component: import("@/components/modules/payment"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    })
  },
  data() {
    return {
      scrollHeight: {
        contentToolbarHeight: 0,
        nav: 0,
        content: 0,
        right: 0
      },

      modalSuccess: false,
      invoiceSuccessRdy: false,
      invoiceSuccess: {},
      hasEbarimt: false,
    };
  },
  mounted() {
    this.toggleBodyClass("addClass", "app-lms");
    require("@/assets/css/dynamic.lms.css");

    window.addEventListener("resize", this.getWindowHeight);
    this.getWindowHeight();

    let _ebarimt = this.$store.state.app.groupSettings.filter(
      (x) => x.key == "paymentEbarimt"
    );
    if (
      _ebarimt.length > 0 &&
      _ebarimt[0].value != undefined &&
      _ebarimt[0].value == "1"
    ) {
      this.hasEbarimt = true;
    }
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.getWindowHeight);
    this.toggleBodyClass("removeClass", "app-lms");
  },
  destroyed() {
    window.removeEventListener("resize", this.getWindowHeight);
    this.toggleBodyClass("removeClass", "app-lms");
  },
  methods: {
    ...mapActions(["handleUserInfo"]),
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;

      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    toggleNavbar(shown) {
      if (this.navbarMode == 0) {
        this.navbarMode = 1;
        this.toggleBodyClass("addClass", "lms-sidebar-show");
      } else if (this.navbarMode == 1) {
        if (shown) {
          this.toggleBodyClass("addClass", "navbar-nav-show");
        } else {
          this.navbarMode = 0;
          this.toggleBodyClass("removeClass", "lms-sidebar-show");
        }
      }
    },
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;

      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    toggleNavbar(shown) {
      if (this.navbarMode == 0) {
        this.navbarMode = 1;
        this.toggleBodyClass("addClass", "lms-sidebar-show");
      } else if (this.navbarMode == 1) {
        if (shown) {
          this.toggleBodyClass("addClass", "navbar-nav-show");
        } else {
          this.navbarMode = 0;
          this.toggleBodyClass("removeClass", "lms-sidebar-show");
        }
      }
    },
    getWindowHeight() {
      let contentSub = 120;
      let navSub = 120;
      let rightSub = 120;
      if (screen.width <= 1024) {
        contentSub = 85;
        navSub = 85;
        rightSub = 85;
      }

      contentSub += this.scrollHeight.contentToolbarHeight;
      rightSub += this.scrollHeight.contentToolbarHeight;

      this.scrollHeight.content = window.innerHeight - contentSub;
      this.scrollHeight.nav = window.innerHeight - navSub;
      this.scrollHeight.right = window.innerHeight - rightSub;
    },
    onPaySuccess(e) {
      //console.log("onPaySuccess", e);
      if (e.product.objectTypeId == 280)
        this.handleUserInfo({ store: this.$store });
      //fetchUserInfo

      this.invoiceSuccess = e;
      this.invoiceSuccessRdy = true;
      this.modalSuccess = true;
    },
    courseDetail() {
      if (this.invoiceSuccess.product.objectTypeId == 115) {
        this.$router.push(
          `/lms/courseView/${this.invoiceSuccess.product.id}/0/0/0`
        );
      } else {
        this.$router.push("/");
      }
    },
    goToEbarimt(){
      this.$router.push({
        name: 'lmsPaymentList',
        params:{
          status: 1,
          cur: this.invoiceSuccess.id
        }
      });
    },
    pushInvoiceDetail() {
      if (this.invoiceSuccess.product.objectTypeId == 181) {
        if (this.invoiceSuccess.product.secondAttachmentId != null) {
          this.$router.push(
            `/lms/library/${this.invoiceSuccess.product.secondAttachmentId}/${this.invoiceSuccess.product.id}/${this.invoiceSuccess.product.task}/0`
          );
        } else {
          this.$router.push("/");
        }
      } else {
        this.$router.push("/");
      }
    },
    checkCourseIsActive() {
      //console.log(this.invoiceSuccess.product);
      if (
        moment(this.invoiceSuccess.product.date.end).isBefore(
          moment(this.invoiceSuccess.product.date.now)
        )
      ) {
        //# duussan
        return -1;
      } else if (
        moment(this.invoiceSuccess.product.date.start).isBefore(
          moment(this.invoiceSuccess.product.date.now)
        ) &&
        moment(this.invoiceSuccess.product.date.end).isAfter(
          moment(this.invoiceSuccess.product.date.now)
        )
      ) {
        //# urgeljilj bgaa
        return 1;
      } else if (
        moment(this.invoiceSuccess.product.date.start).isAfter(
          moment(this.invoiceSuccess.product.date.now)
        )
      ) {
        //# ehleegui
        return 0;
      }
    }
  }
};
</script>
